import TableView from "../Common/TableView";
import { OrcamentosTableConfigs } from "./Orcamentos.config";
import { generalObjectBuilder, genericDelete, genericPost, genericUpdate, ORCAMENTOS_EXTENSION, paginatedGetWithProcessor } from "../../services/api.service";
import { useState } from "react";
import Modal from 'react-modal';
import CustomButtonSimple from "../../components/CustomMiscellaneous/CustomButtonSimple";
import { Info } from "@mui/icons-material";

function InstrucoesDeVenda() {

    const [instrucoesOpen, setInstrucoesOpen] = useState(false);


    return (
        <>
            {
                instrucoesOpen ?
                    <Modal className={"justify-self-center justify-center flex w-full h-full p-32 px-20 z-[1000]"} isOpen={instrucoesOpen}>
                        < div className="bg-white opacity-100 flex flex-col w-4/5 rounded-md shadow-lg z-[1200] h-fit" >
                            <div className="flex w-full justify-between  bg-rodrimaq-red rounded-t-md p-3">
                                <div className="text-white font-bold">Instruções de venda</div>
                                <div className="text-white cursor-pointer hover:underline" onClick={() => setInstrucoesOpen(false)}>Fechar</div>
                            </div>
                            <div className="p-5 px-12">
                                <div className="text-lg">
                                    <div ><span className="font-bold">1.</span> Receção da Consulta do cliente pelos canais de comunicação</div>
                                    <hr className="mb-5" />
                                    <div><span className="font-bold">2.</span> Arquivar a informação no servidor&gt;Pasta Orçamentação&gt;Pasta com data&gt;Pasta com nome do cliente</div>
                                    <hr className="mb-5" />
                                    <div><span className="font-bold">3.</span> Fazer cálculos de orçamento&gt;Criar documento em PDF com o nome “Orçamento_Cliente_Ano_nº”</div>
                                    <hr className="mb-5" />
                                    <div ><span className="font-bold">4.</span> Enviar Doc. Ao cliente&gt;Colocar orçamento na pasta “orçamentos em analise”</div>
                                    <hr className="mb-5" />
                                    <div ><span className="font-bold">5.</span> Fazer seguimento do orçamento por chamada, Email ou visita</div>
                                    <hr className="mb-5" />
                                    <div ><span className="font-bold">6.</span> Abrir obra ou arquivar (Servidor&gt;Pasta Orçamentos&gt;Pasta Ano&gt;Pasta Cliente)</div>
                                    <hr className="mb-5" />
                                </div>
                            </div>
                        </div >
                    </Modal >
                    : null
            }


            <CustomButtonSimple color="#3498eb" className="mr-4" text={"Instruções de venda"} onClick={() => setInstrucoesOpen(true)} Icon={Info} />
        </>
    )



}



export default function Orcamentos() {


    const cachedOrcamento = localStorage.getItem('orcamentosForm') ? JSON.parse(localStorage.getItem('orcamentosForm') as string) : null;


    return (<div className="max-h-screen">
        <TableView
            title={"Orçamentos"}
            getEntity={paginatedGetWithProcessor(ORCAMENTOS_EXTENSION, generalObjectBuilder(OrcamentosTableConfigs))}
            postEntity={genericPost(ORCAMENTOS_EXTENSION)}
            editEntity={genericUpdate(ORCAMENTOS_EXTENSION)}
            deleteEntity={genericDelete(ORCAMENTOS_EXTENSION)}
            addButtonText={cachedOrcamento ? `Terminar orçamento ${cachedOrcamento.billCode}` :"Novo Orçamento"}
            extraActions={<InstrucoesDeVenda />}
            searchButtonText={"Procurar Orçamento"}
            tableConfigs={OrcamentosTableConfigs}
            dataBuildFunction={generalObjectBuilder(OrcamentosTableConfigs)}
            entityName={"Orçamento"}
            idProp={"billCode"}
            reroute={true}
            customForm
        />
    </div>)

}

